// extracted by mini-css-extract-plugin
export default {"container":"Writing_container__yTk5I","textarea":"Writing_textarea__W7IJO","keyboard":"Writing_keyboard__SzCR1"};